export const SMALL_LABEL_PRODUCTION_PROFILE_ID = "small-labels-mimaki-ucjv330";
export const TINY_LABEL_PRODUCTION_PROFILE_ID = "tiny-labels-mimaki-ucjv330";
export const LARGE_LABEL_PRODUCTION_PROFILE_ID = "large-labels-mimaki-ucjv330";
export const LUNCHBOX_LABEL_PRODUCTION_PROFILE_ID = "lunchbox-labels-mimaki-ucjv330";
export const QR_LABEL_PRODUCTION_PROFILE_ID = "qr-labels-mimaki-ucjv330";

export const DEFAULT_PRODUCTION_SETTINGS = {
  generateOnlyAfterPayment: true,
  includeJobSheet: false,
  shopifyPaidStatuses: ["paid", "partially_refunded"],
  magentoPaidStatuses: ["processing", "complete"],
  profiles: [
    {
      id: SMALL_LABEL_PRODUCTION_PROFILE_ID,
      name: "Vanlige navnlapper - Mimaki UCJV330-160",
      active: true,
      templateIds: ["template-small-name-labels"],
      pageWidthMm: 200,
      pageHeightMm: 307,
      marginMm: 4,
      headerHeightMm: 18,
      headerGapMm: 0,
      headerText: "www.navnlapp.no",
      headerLogoUrl: "/production-logos/assistco-navnlapp.png",
      headerLogoHeightMm: 18.75,
      headerLogoMaxWidthMm: 32,
      productBarcode: "8674512",
      barcodeWidthMm: 50,
      barcodeHeightMm: 9,
      headerTextSizePt: 14,
      barcodeTextSizePt: 14,
      productBarcodeScale: 0.9,
      orderBarcodeScale: 0.6,
      showOrderBarcode: true,
      showHeaderCutLine: true,
      headerCutLineInsetMm: 5,
      // Extend the vector path outside the PDF edges so RasterLink clips one
      // continuous knife path through the complete 0-200 mm sheet width.
      headerCutLineOverrunMm: 2,
      labelWidthMm: 30,
      labelHeightMm: 12.9,
      // Keep colour safely outside CutContour while reserving a 0.5 mm white
      // separator in the 1 mm production pitch. This gives 0.25 mm bleed from
      // each neighbouring label without changing the 30 x 12.9 mm trim size.
      bleedMm: 0.5,
      gutterMm: 1,
      whiteSeparatorMm: 0.5,
      gapXmm: 1,
      gapYmm: 1,
      columns: 6,
      rows: 20,
      extraGapAfterRow: 9,
      extraGapMm: 3,
      cornerRadiusMm: 3,
      cutContourName: "CutContour",
      cutStrokePt: 0.3,
      storeHeaderOverrides: [
        {
          storeId: "store-sportmann-magento",
          headerText: "www.sportmann.no",
          headerLogoUrl: "/production-logos/sportmann.png",
          headerLogoMaxWidthMm: 42,
        },
      ],
    },
    {
      id: TINY_LABEL_PRODUCTION_PROFILE_ID,
      name: "Små navnelapper - Mimaki UCJV330-160",
      active: true,
      templateIds: ["template-tiny-name-labels"],
      layoutMode: "dynamic-grid",
      copiesPerSet: 1,
      sourceDpi: 300,
      pageWidthMm: 200,
      pageHeightMm: 307,
      marginMm: 4,
      headerHeightMm: 18,
      headerGapMm: 0,
      headerText: "www.navnlapp.no",
      headerLogoUrl: "/production-logos/assistco-navnlapp.png",
      headerLogoHeightMm: 18.75,
      headerLogoMaxWidthMm: 32,
      productBarcode: "8674513",
      barcodeWidthMm: 50,
      barcodeHeightMm: 9,
      headerTextSizePt: 14,
      barcodeTextSizePt: 14,
      productBarcodeScale: 0.9,
      orderBarcodeScale: 0.6,
      showOrderBarcode: true,
      showHeaderCutLine: true,
      headerCutLineInsetMm: 5,
      headerCutLineOverrunMm: 2,
      labelWidthMm: 16,
      labelHeightMm: 6,
      bleedMm: 0.5,
      gapXmm: 1,
      gapYmm: 1,
      columns: 10,
      rows: 18,
      extraGapAfterRow: 9,
      extraGapMm: 3,
      cornerRadiusMm: 1.2,
      cutContourName: "CutContour",
      cutStrokePt: 0.3,
      storeHeaderOverrides: [],
    },
    {
      id: LARGE_LABEL_PRODUCTION_PROFILE_ID,
      name: "Store navnlapper - Mimaki UCJV330-160",
      active: true,
      templateIds: ["template-large-name-labels"],
      layoutMode: "large-sheet-triplicate",
      copiesPerSet: 3,
      sourceDpi: 300,
      pageWidthMm: 200,
      pageHeightMm: 307,
      marginMm: 4,
      headerHeightMm: 18,
      headerGapMm: 0,
      headerText: "www.navnlapp.no",
      headerLogoUrl: "/production-logos/assistco-navnlapp.png",
      headerLogoHeightMm: 18.75,
      headerLogoMaxWidthMm: 32,
      productBarcode: "8674516",
      barcodeWidthMm: 50,
      barcodeHeightMm: 9,
      headerTextSizePt: 14,
      barcodeTextSizePt: 14,
      productBarcodeScale: 0.9,
      orderBarcodeScale: 0.6,
      showOrderBarcode: true,
      showHeaderCutLine: true,
      headerCutLineInsetMm: 5,
      headerCutLineOverrunMm: 2,
      labelWidthMm: 169.333,
      labelHeightMm: 86.614,
      bleedMm: 0,
      gapXmm: 0,
      gapYmm: 1,
      columns: 1,
      rows: 3,
      extraGapAfterRow: 0,
      extraGapMm: 0,
      cornerRadiusMm: 0.68,
      // Keep the physical knife path safely inside the printed large-label
      // artwork so small registration tolerances can never expose white.
      cutInsetMm: 1,
      cutContourName: "CutContour",
      cutStrokePt: 0.3,
      storeHeaderOverrides: [],
    },
    {
      id: LUNCHBOX_LABEL_PRODUCTION_PROFILE_ID,
      name: "Matboksmerker - Mimaki UCJV330-160",
      active: true,
      templateIds: ["template-lunchbox-labels"],
      layoutMode: "dynamic-grid",
      copiesPerSet: 1,
      sourceDpi: 300,
      pageWidthMm: 200,
      pageHeightMm: 307,
      marginMm: 4,
      headerHeightMm: 18,
      headerGapMm: 0,
      headerText: "www.navnlapp.no",
      headerLogoUrl: "/production-logos/assistco-navnlapp.png",
      headerLogoHeightMm: 18.75,
      headerLogoMaxWidthMm: 32,
      productBarcode: "8674517",
      barcodeWidthMm: 50,
      barcodeHeightMm: 9,
      headerTextSizePt: 14,
      barcodeTextSizePt: 14,
      productBarcodeScale: 0.9,
      orderBarcodeScale: 0.6,
      showOrderBarcode: true,
      showHeaderCutLine: true,
      headerCutLineInsetMm: 5,
      headerCutLineOverrunMm: 2,
      labelWidthMm: 90,
      labelHeightMm: 120,
      bleedMm: 3,
      gapXmm: 6,
      gapYmm: 6,
      columns: 1,
      rows: 1,
      extraGapAfterRow: 0,
      extraGapMm: 0,
      cornerRadiusMm: 9,
      cutContourName: "CutContour",
      cutStrokePt: 0.3,
      storeHeaderOverrides: [],
    },
    {
      id: QR_LABEL_PRODUCTION_PROFILE_ID,
      name: "QR-kodelapper - Mimaki UCJV330-160",
      active: true,
      templateIds: ["template-qr-code-labels"],
      layoutMode: "dynamic-grid",
      copiesPerSet: 1,
      sourceDpi: 300,
      pageWidthMm: 200,
      pageHeightMm: 307,
      marginMm: 4,
      headerHeightMm: 18,
      headerGapMm: 0,
      headerText: "www.navnlapp.no",
      headerLogoUrl: "/production-logos/assistco-navnlapp.png",
      headerLogoHeightMm: 18.75,
      headerLogoMaxWidthMm: 32,
      productBarcode: "QR-LABELS",
      barcodeWidthMm: 50,
      barcodeHeightMm: 9,
      headerTextSizePt: 14,
      barcodeTextSizePt: 14,
      productBarcodeScale: 0.9,
      orderBarcodeScale: 0.6,
      showOrderBarcode: true,
      showHeaderCutLine: true,
      headerCutLineInsetMm: 5,
      headerCutLineOverrunMm: 2,
      labelWidthMm: 30,
      labelHeightMm: 30,
      bleedMm: 0.5,
      gapXmm: 1,
      gapYmm: 1,
      columns: 6,
      rows: 9,
      extraGapAfterRow: 0,
      extraGapMm: 0,
      cornerRadiusMm: 3,
      cutContourName: "CutContour",
      cutStrokePt: 0.3,
      storeHeaderOverrides: [],
    },
  ],
};

export function normalizeProductionSettings(input) {
  const defaults = structuredClone(DEFAULT_PRODUCTION_SETTINGS);
  const source = input && typeof input === "object" ? input : {};
  const sourceProfiles = Array.isArray(source.profiles) ? source.profiles : [];
  const storedById = new Map(sourceProfiles.map((profile) => [profile?.id, profile]));
  const defaultIds = new Set(defaults.profiles.map((profile) => profile.id));
  const profiles = [
    ...defaults.profiles.map((profile) => ({ ...profile, ...(storedById.get(profile.id) || {}) })),
    ...sourceProfiles.filter((profile) => profile?.id && !defaultIds.has(profile.id)),
  ];
  return {
    ...defaults,
    ...source,
    generateOnlyAfterPayment: source.generateOnlyAfterPayment !== false,
    includeJobSheet: source.includeJobSheet === true,
    shopifyPaidStatuses: normalizeStatuses(source.shopifyPaidStatuses, defaults.shopifyPaidStatuses),
    magentoPaidStatuses: normalizeStatuses(source.magentoPaidStatuses, defaults.magentoPaidStatuses),
    profiles: profiles.map((profile) => normalizeProductionProfile(profile)),
  };
}

export function normalizeProductionProfile(input) {
  const source = input && typeof input === "object" ? input : {};
  const defaults = DEFAULT_PRODUCTION_SETTINGS.profiles.find((profile) => profile.id === source.id) || DEFAULT_PRODUCTION_SETTINGS.profiles[0];
  return {
    ...structuredClone(defaults),
    ...source,
    id: boundedText(source.id || defaults.id, 80),
    name: boundedText(source.name || defaults.name, 120),
    active: source.active !== false,
    layoutMode: ["fixed-grid", "dynamic-grid", "large-sheet-triplicate"].includes(source.layoutMode) ? source.layoutMode : (defaults.layoutMode || "fixed-grid"),
    copiesPerSet: boundedInteger(source.copiesPerSet, defaults.copiesPerSet || 1, 1, 20),
    sourceDpi: boundedInteger(source.sourceDpi, defaults.sourceDpi || 300, 72, 1200),
    templateIds: Array.isArray(source.templateIds) && source.templateIds.length
      ? source.templateIds.map((value) => boundedText(value, 120)).filter(Boolean)
      : [...defaults.templateIds],
    pageWidthMm: boundedNumber(source.pageWidthMm, defaults.pageWidthMm, 50, 1610),
    pageHeightMm: boundedNumber(source.pageHeightMm, defaults.pageHeightMm, 50, 5000),
    marginMm: boundedNumber(source.marginMm, defaults.marginMm, 0, 50),
    headerHeightMm: boundedNumber(source.headerHeightMm, defaults.headerHeightMm, 0, 100),
    headerGapMm: boundedNumber(source.headerGapMm, defaults.headerGapMm, 0, 30),
    headerText: boundedText(source.headerText ?? defaults.headerText, 100),
    headerLogoUrl: safeAssetUrl(source.headerLogoUrl ?? defaults.headerLogoUrl),
    headerLogoHeightMm: boundedNumber(source.headerLogoHeightMm, defaults.headerLogoHeightMm, 1, 50),
    headerLogoMaxWidthMm: boundedNumber(source.headerLogoMaxWidthMm, defaults.headerLogoMaxWidthMm, 5, 100),
    productBarcode: boundedText(source.productBarcode ?? defaults.productBarcode, 80),
    barcodeWidthMm: boundedNumber(source.barcodeWidthMm, defaults.barcodeWidthMm, 10, 100),
    barcodeHeightMm: boundedNumber(source.barcodeHeightMm, defaults.barcodeHeightMm, 3, 30),
    headerTextSizePt: boundedNumber(source.headerTextSizePt, defaults.headerTextSizePt || 14, 6, 72),
    barcodeTextSizePt: boundedNumber(source.barcodeTextSizePt, defaults.barcodeTextSizePt || 14, 6, 36),
    productBarcodeScale: boundedNumber(source.productBarcodeScale, defaults.productBarcodeScale, 0.1, 1.5),
    orderBarcodeScale: boundedNumber(source.orderBarcodeScale, defaults.orderBarcodeScale, 0.1, 1.5),
    showOrderBarcode: source.showOrderBarcode !== false,
    showHeaderCutLine: source.showHeaderCutLine !== false,
    headerCutLineInsetMm: boundedNumber(source.headerCutLineInsetMm, defaults.headerCutLineInsetMm, 0, 50),
    headerCutLineOverrunMm: boundedNumber(source.headerCutLineOverrunMm, defaults.headerCutLineOverrunMm || 2, 0, 10),
    labelWidthMm: boundedNumber(source.labelWidthMm, defaults.labelWidthMm, 3, 500),
    labelHeightMm: boundedNumber(source.labelHeightMm, defaults.labelHeightMm, 3, 500),
    bleedMm: boundedNumber(source.bleedMm, defaults.bleedMm, 0, 5),
    gutterMm: boundedNumber(source.gutterMm, defaults.gutterMm || 0, 0, 10),
    whiteSeparatorMm: boundedNumber(source.whiteSeparatorMm, defaults.whiteSeparatorMm || 0, 0, 10),
    gapXmm: boundedNumber(source.gapXmm, defaults.gapXmm, 0, 30),
    gapYmm: boundedNumber(source.gapYmm, defaults.gapYmm, 0, 30),
    columns: boundedInteger(source.columns, defaults.columns, 1, 100),
    rows: boundedInteger(source.rows, defaults.rows, 1, 200),
    extraGapAfterRow: boundedInteger(source.extraGapAfterRow, defaults.extraGapAfterRow, 0, 200),
    extraGapMm: boundedNumber(source.extraGapMm, defaults.extraGapMm, 0, 30),
    cornerRadiusMm: boundedNumber(source.cornerRadiusMm, defaults.cornerRadiusMm, 0, 50),
    cutInsetMm: boundedNumber(source.cutInsetMm, defaults.cutInsetMm || 0, 0, 20),
    cutContourName: boundedText(source.cutContourName || defaults.cutContourName, 60).replace(/[^A-Za-z0-9_-]/g, "") || "CutContour",
    cutStrokePt: boundedNumber(source.cutStrokePt, defaults.cutStrokePt, 0.05, 3),
    storeHeaderOverrides: normalizeStoreHeaderOverrides(source.storeHeaderOverrides ?? defaults.storeHeaderOverrides),
  };
}

export function productionBrandingForStore(profileInput, storeId) {
  const profile = normalizeProductionProfile(profileInput);
  const override = profile.storeHeaderOverrides.find((item) => item.storeId === String(storeId || ""));
  return {
    headerText: override?.headerText || profile.headerText,
    headerLogoUrl: override?.headerLogoUrl || profile.headerLogoUrl,
    headerLogoHeightMm: override?.headerLogoHeightMm || profile.headerLogoHeightMm,
    headerLogoMaxWidthMm: override?.headerLogoMaxWidthMm || profile.headerLogoMaxWidthMm,
  };
}

export function productionProfileForTemplate(settings, templateId) {
  const normalized = normalizeProductionSettings(settings);
  return normalized.profiles.find((profile) => profile.active !== false && profile.templateIds.includes(templateId)) || null;
}

export function calculateProductionLayout(profileInput) {
  const profile = normalizeProductionProfile(profileInput);
  const usableWidthMm = profile.pageWidthMm - 2 * profile.marginMm;
  const usableHeightMm = profile.pageHeightMm - 2 * profile.marginMm - profile.headerHeightMm - profile.headerGapMm;
  const gridWidthMm = profile.columns * profile.labelWidthMm + Math.max(0, profile.columns - 1) * profile.gapXmm;
  const hasExtraGap = profile.extraGapAfterRow > 0 && profile.extraGapAfterRow < profile.rows;
  const gridHeightMm = profile.rows * profile.labelHeightMm
    + Math.max(0, profile.rows - 1) * profile.gapYmm
    + (hasExtraGap ? profile.extraGapMm : 0);
  const errors = [];
  if (gridWidthMm > usableWidthMm + 0.001) errors.push(`Rutenettet er ${(gridWidthMm - usableWidthMm).toFixed(1)} mm for bredt.`);
  if (gridHeightMm > usableHeightMm + 0.001) errors.push(`Rutenettet er ${(gridHeightMm - usableHeightMm).toFixed(1)} mm for høyt.`);
  if (profile.bleedMm * 2 > profile.gapXmm + 0.001 || profile.bleedMm * 2 > profile.gapYmm + 0.001) {
    errors.push("Utfallende trykk overlapper neste etikett. Øk avstanden eller reduser bleed.");
  }
  if (profile.cornerRadiusMm * 2 > Math.min(profile.labelWidthMm, profile.labelHeightMm)) errors.push("Hjørneradiusen er større enn etiketten tillater.");
  return {
    profile,
    usableWidthMm,
    usableHeightMm,
    gridWidthMm,
    gridHeightMm,
    startXmm: profile.marginMm,
    startTopMm: profile.marginMm + profile.headerHeightMm + profile.headerGapMm,
    labelsPerSheet: profile.columns * profile.rows,
    errors,
    valid: errors.length === 0,
  };
}

export function isPaidStatus(platform, status, settings) {
  const normalized = normalizeProductionSettings(settings);
  const value = String(status || "").trim().toLowerCase();
  const paidStatuses = platform === "magento" ? normalized.magentoPaidStatuses : normalized.shopifyPaidStatuses;
  return paidStatuses.includes(value);
}

function normalizeStatuses(input, fallback) {
  const statuses = Array.isArray(input) ? input : fallback;
  return [...new Set(statuses.map((value) => String(value || "").trim().toLowerCase()).filter(Boolean))];
}

function boundedNumber(value, fallback, min, max) {
  const number = Number(value);
  return Number.isFinite(number) ? Math.min(max, Math.max(min, number)) : fallback;
}

function boundedInteger(value, fallback, min, max) {
  return Math.round(boundedNumber(value, fallback, min, max));
}

function boundedText(value, max) {
  return String(value ?? "").trim().slice(0, max);
}

function safeAssetUrl(value) {
  const url = boundedText(value, 500);
  if (!url) return "";
  if (url.startsWith("/") && !url.startsWith("//")) return url;
  try {
    const parsed = new URL(url);
    return parsed.protocol === "https:" ? parsed.toString() : "";
  } catch {
    return "";
  }
}

function normalizeStoreHeaderOverrides(input) {
  if (!Array.isArray(input)) return [];
  return input.slice(0, 100).map((item) => ({
    storeId: boundedText(item?.storeId, 120),
    headerText: boundedText(item?.headerText, 100),
    headerLogoUrl: safeAssetUrl(item?.headerLogoUrl),
    headerLogoHeightMm: item?.headerLogoHeightMm ? boundedNumber(item.headerLogoHeightMm, 18.75, 1, 50) : undefined,
    headerLogoMaxWidthMm: item?.headerLogoMaxWidthMm ? boundedNumber(item.headerLogoMaxWidthMm, 32, 5, 100) : undefined,
  })).filter((item) => item.storeId);
}
